import { render, staticRenderFns } from "./ProxyAgreeModal.vue?vue&type=template&id=19d22284&scoped=true&"
import script from "./ProxyAgreeModal.vue?vue&type=script&lang=ts&"
export * from "./ProxyAgreeModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProxyAgreeModal.vue?vue&type=style&index=0&id=19d22284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d22284",
  null
  
)

export default component.exports